import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getDoneWorksCalculationMaterialsMetrics: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].GET_DONE_WORKS_CALCULATION_MATERIALS_METRICS,
	},
	getDoneWorksCalculationMaterialsMetricPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].GET_DONE_WORKS_CALCULATION_MATERIALS_METRIC_PREVIEW,
	},
	getDoneWorksCalculationMaterialsMetricPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].GET_DONE_WORKS_CALCULATION_MATERIALS_METRIC_POPUP,
	},
	createDoneWorksCalculationMaterialsMetric: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].CREATE_DONE_WORKS_CALCULATION_MATERIALS_METRIC,
	},
	getDoneWorksCalculationMaterialsMetric: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].GET_DONE_WORKS_CALCULATION_MATERIALS_METRIC,
	},
	patchDoneWorksCalculationMaterialsMetric: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].PATCH_DONE_WORKS_CALCULATION_MATERIALS_METRIC,
	},
	patchDoneWorksCalculationMaterialsMetricBulkUpdate: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].PATCH_DONE_WORKS_CALCULATION_MATERIALS_METRIC_BULK_UPDATE,
	},
	putDoneWorksCalculationMaterialsMetric: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].PUT_DONE_WORKS_CALCULATION_MATERIALS_METRIC,
	},
	deleteDoneWorksCalculationMaterialsMetric: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS].DELETE_DONE_WORKS_CALCULATION_MATERIALS_METRIC,
	},
}